import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading, checkAuth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const authChecked = useRef(false);

  useEffect(() => {
    // If we have a session_id in the hash, let AuthCallback handle it
    if (location.hash.includes('session_id=')) {
      setChecking(false);
      return;
    }

    // If already have user, no need to check
    if (user) {
      setChecking(false);
      authChecked.current = true;
      return;
    }

    // If still loading initial auth, wait
    if (loading) {
      return;
    }

    // No user and not loading - try ONE auth check (not repeated)
    if (!authChecked.current) {
      authChecked.current = true;
      const verify = async () => {
        const result = await checkAuth();
        setChecking(false);
        if (!result) {
          navigate("/", { replace: true });
        }
      };
      verify();
    } else {
      // Already checked and no user -> redirect
      setChecking(false);
      navigate("/", { replace: true });
    }
  }, [loading, user]);

  // Show loading during auth check
  if (loading || checking) {
    return (
      <div className="mobile-container flex items-center justify-center min-h-screen bg-stone-900">
        <Loader2 className="w-12 h-12 text-amber-500 animate-spin" />
      </div>
    );
  }

  // If no user, don't render (redirect will happen via useEffect)
  if (!user) return null;

  return children;
};

export default ProtectedRoute;
